module.exports = __webpack_public_path__ + "img/bg.a47de82c.png";